import { useEffect, useState } from "react";
import fetchData from "../../../shared/fetchData";
import Button from "../../UI/Button/Button";
import ContentForm from "../../UI/ContentForm/ContentForm";
import Select from "../../UI/Select/Select";
import { toast } from "react-toastify";

const ChangeBoxOrder = (props) => {
  const [lockers, setLockers] = useState([]);
  const [kiosks, setKiosks] = useState([]);
  const [locker, setLocker] = useState("");
  const [kiosk, setKiosk] = useState("");
  const [invalidBox, setInvalidBox] = useState(false);
  useEffect(() => {
    var raw = JSON.stringify({
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    });
    var url = "management/api/v1/kiosks/getKiosks";
    fetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          setKiosks(result.kiosks);
          const ksk = result.kiosks?.filter(
            (k) => k.id === props?.order?.kiosk?.id
          );
          if (!!ksk && ksk.length > 0) {
            setKiosk(ksk[0]);
            var raw = JSON.stringify({
              locker: {
                kiosk: {
                  id: ksk[0].value,
                },
              },
              pl: 1000,
              pn: 1,
              version: "mtpx001",
            });
            var url = "management/api/v1/lockers/getLockers";
            fetchData(raw, url)
              .then((response) => response.json())
              .then((result) => {
                if (result.status == 0) {
                  setLockers(result.lockers);
                  const lckr = result.lockers?.filter(
                    (l) => l.id === props?.order?.locker?.id
                  );
                  if (!!lckr && lckr.length > 0) {
                    setLocker(lckr[0]);
                  }
                }
              })
              .catch((error) => console.log(error));
          }
        }
      })
      .catch((error) => console.log(error));
  }, []);

  const changeKiosk = (selectedOption) => {
    setKiosk(selectedOption);
    var raw = JSON.stringify({
      locker: {
        kiosk: {
          id: selectedOption.value,
        },
      },
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    });
    var url = "management/api/v1/lockers/getLockers";
    fetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          setLockers(result.lockers);
        }
      })
      .catch((error) => console.log(error));
  };
  const changeOrderBoxSubmit = (event) => {
    let valid = true;
    if (locker == null || locker == "" || kiosk == null || kiosk == "") {
      valid = false;
      setInvalidBox(true);
    }
    var info = {
      orderId: props.order?.id,
      lockerId: locker?.value,
      version: "mtpx001",
    };
    var raw = JSON.stringify(info);
    var url = "management/api/v1/orders/changeOrderBox";
    fetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == "0") {
          toast.success("عملیات با موفقیت انجام شد");
          props.closeAndReload();
        }
      })
      .catch((error) => console.log(error));
  };
  const kioskList = [];
  if (kiosks != null && kiosks.length != 0) {
    kiosks.map((z) => {
      kioskList.push({
        value: z.id,
        label: z.description,
      });
    });
  }
  const lockerList = [];
  if (lockers != null && lockers.length != 0) {
    lockers.map((z) => {
      lockerList.push({
        value: z.id,
        label: z.serial + "-" + z.lockerType.description,
      });
    });
  }

  return (
    <div
      className="row justify-content-center p-3 pr-5 pl-5"
      style={{ marginTop: "-30px" }}
    >
      <ContentForm headetText="اطلاعات سفارش">
        <div className="col-12 p-0 small-ord-col">
          <Select
            name="form-field-name"
            value={kiosk}
            placeholder="لاکر"
            options={kioskList}
            onChange={changeKiosk}
            className={
              invalidBox && (kiosk == null || kiosk == "")
                ? "invalid-select"
                : ""
            }
          />
        </div>
        <div className="col-12 p-0 small-ord-col">
          <Select
            name="form-field-name"
            value={locker}
            placeholder="شناسه باکس"
            onChange={(value) => setLocker(value)}
            className={
              invalidBox && (locker == null || locker == "")
                ? "invalid-select"
                : ""
            }
            options={lockerList}
          />
        </div>
        <div className="row justify-content-center w-100 mt-3">
          <div className="col-6 text-center">
            <Button btnType="General" clicked={(event) => props.handleClose()}>
              برگشت
            </Button>
          </div>
          <div className="col-6 text-center">
            <Button btnType="Success" clicked={changeOrderBoxSubmit}>
              ثبت
            </Button>
          </div>
        </div>
      </ContentForm>
    </div>
  );
};

export default ChangeBoxOrder;
